import React, { cloneElement } from 'react';
import { GenerateIcon, ICONS, Tabs, TabsContent, TabsList, TabsTrigger } from '@pileus-cloud/anodot-frontend-common';
import styles from './Tabs.module.scss';

const tabTriggerCreator = (index, name, icon, items) => {
  const displayText = items ? `(${items})` : '';
  return (
    <TabsTrigger value={index} key={`${index}-${name}`}>
      <div className={styles.triggerWrapper}>
        {icon && <GenerateIcon key={ICONS[icon].name} iconName={ICONS[icon].name} />}
        <span key={name}>{`${name} ${displayText}`}</span>
      </div>
    </TabsTrigger>
  );
};

const tabContentCreator = (index, title, children, className) => {
  const elements = React.Children.toArray(children);
  return (
    <TabsContent key={`${index}-${title}`} value={index} className={className}>
      {title ? (
        <div key={title} className={styles.title}>
          {title}
        </div>
      ) : null}
      <div key={index}>{cloneElement(elements[index])}</div>
    </TabsContent>
  );
};

const ColoredTabs = ({
  className,
  arrOfNavItems,
  defaultAccountIndex = 0,
  children,
  vertical = false,
  onTabChange = null,
  staticInfo,
  selectedIndex,
}) => (
  <div>
    <Tabs
      defaultValue={defaultAccountIndex}
      value={selectedIndex !== null ? selectedIndex : undefined}
      orientation={vertical ? 'vertical' : 'horizontal'}
      onValueChange={(data) => onTabChange && onTabChange(data.value)}
    >
      <TabsList key="tabList" className={staticInfo ? styles.tabWrapper : null}>
        <div key="verticalContainer" className={vertical ? styles.flexColumn : null}>
          {arrOfNavItems.map((navItem) => tabTriggerCreator(navItem.id, navItem.name, navItem.icon, navItem.items))}
        </div>
        {staticInfo}
      </TabsList>
      {arrOfNavItems.map((navItem) => tabContentCreator(navItem.id, navItem.title, children, className))}
    </Tabs>
  </div>
);

export default ColoredTabs;
